import { buildResultAccessScope } from '@/core/credit/resultAccessScope';

const toTrimmedString = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim();
};

const resolveTransportPayload = (response = {}) => {
  if (!response || typeof response !== 'object') {
    return response;
  }

  if (response.data && typeof response.data === 'object') {
    return response.data;
  }

  if (response.payload && typeof response.payload === 'object') {
    return response.payload;
  }

  return response;
};

const normalizeUnlockedFeatures = (rawUnlockedFeatures) => {
  if (!Array.isArray(rawUnlockedFeatures)) {
    return rawUnlockedFeatures;
  }

  const parseCombinedCode = (rawCode) => {
    const normalizedCode = toTrimmedString(rawCode);
    if (!normalizedCode) {
      return null;
    }

    const dotIndex = normalizedCode.indexOf('.');
    if (dotIndex <= 0 || dotIndex === normalizedCode.length - 1) {
      return null;
    }

    return {
      featureCode: normalizedCode.slice(0, dotIndex),
      subFeatureCode: normalizedCode.slice(dotIndex + 1)
    };
  };

  return rawUnlockedFeatures.map((item) => {
    if (!item || typeof item !== 'object') {
      return item;
    }

    const combined = parseCombinedCode(item.code);

    return {
      featureCode: toTrimmedString(item.featureCode || item.feature_code || combined?.featureCode || item.code),
      subFeatureCode: toTrimmedString(item.subFeatureCode || item.sub_feature_code || combined?.subFeatureCode || 'default') || 'default'
    };
  });
};

const resolveScopeFromPayload = (payload = {}, fallbackScope = {}) => {
  const scopeKey = toTrimmedString(payload.scopeKey || payload.scope_key || fallbackScope.scopeKey);
  const originalHashId = toTrimmedString(
    payload.originalHashId
      || payload.original_hash_id
      || payload.imageId
      || payload.image_id
      || fallbackScope.originalHashId
      || fallbackScope.imageId
  );
  const presetStyleId = toTrimmedString(payload.presetStyleId || payload.preset_style_id || fallbackScope.presetStyleId) || null;
  const scopeType = toTrimmedString(payload.scopeType || payload.scope_type || fallbackScope.scopeType) || undefined;

  const scope = buildResultAccessScope({
    originalHashId,
    presetStyleId,
    scopeType
  });

  if (!scope && !scopeKey) {
    return null;
  }

  return {
    scopeKey: scopeKey || scope?.scopeKey || '',
    scopeType: scope?.scopeType || 'solo',
    originalHashId: scope?.originalHashId || originalHashId,
    presetStyleId: scope?.presetStyleId || presetStyleId
  };
};

export function normalizeUnlockQueryResponse(response = {}, { fallbackScope = null, fallbackImageId = '' } = {}) {
  const payload = resolveTransportPayload(response);
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  const rawUnlockedFeatures = payload.unlockedFeatures ?? payload.unlocked_features;
  const scope = resolveScopeFromPayload(payload, {
    ...(fallbackScope || {}),
    imageId: fallbackImageId
  });

  return {
    scopeKey: scope?.scopeKey || '',
    scopeType: scope?.scopeType || 'solo',
    originalHashId: scope?.originalHashId || toTrimmedString(fallbackImageId),
    presetStyleId: scope?.presetStyleId || null,
    imageId: scope?.originalHashId || toTrimmedString(fallbackImageId),
    unlockedFeatures: normalizeUnlockedFeatures(rawUnlockedFeatures),
    updatedAt: payload.updatedAt ?? payload.updated_at ?? null,
    version: payload.version ?? null
  };
}
